const ExperienceData = [
    {
        status: 'Data Analyst Intern (Remote)',
        year: '2023 Apr - 2023 Jun',
        company:'360digi-TMG',
        logo: require('../../assets/experienceImages/tmg.jpg'),
        skills: 'NumPy · Project Charter · Research Tracker · Data Cleaning · EDA · Pandas (Software) · CRISP-ML(Q) · Matplotlib · Seaborn · SQL',
        works: `Created a Project Charter to outline project objectives and scope.
        - Organized research findings with a Research Tracker.
        - Went through research papers to understand about business data.
        - Employed the CRISP-ML(Q) methodology for data challenges.
        - Utilized Python and SQL for data cleaning and analysis.
        - Transformed raw data into meaningful insights using Pandas, Matplotlib, and Seaborn.
        - Equipped to contribute to data-driven decision-making with business understanding and technical proficiency.`
    },
    {
        status: 'Associate Software Developer (Hybrid)',
        year: '2022 Oct - 2023 Feb',
        company:'IQVIA (M&H Informatics BD)',
        logo: require('../../assets/experienceImages/Iqvia.jpg'),
        skills: 'SQL · Qlik Sense · Microsoft Excel · QlikView',
        works: `Conducted completeness QC for data received in each project wave.\n
        - Ensured accurate and up-to-date data through data refresh and ETL tasks.\n
        - Built Qlik Sense and QlikView dashboards for data visualization.\n
        - Incorporated client feedback to improve project usability.\n
        - Automated report generation for country and cross-country processes\n
         reducing manual effort, improving efficiency, and speeding up project turnaround times.\n
        - Generated sample files for project analysis.\n
        - Produced CSV files for data transfer and storage purposes.`
    },
    {
        status: 'Internship Trainee (Hybrid)',
        year: '2022 Jan -2022 Sep',
        company:'IQVIA (M&H Informatics BD)',
        logo: require('../../assets/experienceImages/Iqvia.jpg'),
        skills: 'Data Warehouse Architecture · Jira · Pharma Data · CRM · Qlik Sense · Microsoft Excel · QlikView · SQL Server Integration Services (SSIS)',
        works:`Got training on DW Architecture - PowerBI - Git and github - Excel - Data Visualization - ETL Processes - SSIS - 
         Data virtualization - Databases - CRM technologies - soft skills - communication skills and many more.`
    }
]

export default ExperienceData